export default __webpack_public_path__ + "static/media/logo.c3b05aa8.png";